// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as Sequence$Showside from "./Sequence.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function ExpandSequence(Props) {
  var isOpenOpt = Props.isOpen;
  var animateOpt = Props.animate;
  var crossFadeOpt = Props.crossFade;
  var topOffset = Props.topOffset;
  var getSourceElOpt = Props.getSourceEl;
  var allowPhaseChange = Props.allowPhaseChange;
  var onPhaseChange = Props.onPhaseChange;
  var onTouchEnd = Props.onTouchEnd;
  var onTouchStart = Props.onTouchStart;
  var onTouchMove = Props.onTouchMove;
  var renderForegroundOpt = Props.renderForeground;
  var autoHideSourceElOpt = Props.autoHideSourceEl;
  var zIndex = Props.zIndex;
  var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
  var animate = animateOpt !== undefined ? animateOpt : true;
  var crossFade = crossFadeOpt !== undefined ? crossFadeOpt : false;
  var getSourceEl = getSourceElOpt !== undefined ? getSourceElOpt : function (param) {};
  var renderForeground = renderForegroundOpt !== undefined ? renderForegroundOpt : function (param, param$1) {
    return null;
  };
  var autoHideSourceEl = autoHideSourceElOpt !== undefined ? autoHideSourceElOpt : true;
  var match = ViewportContext$Showside.use(undefined);
  var breakpoint = match.breakpoint;
  var getBoundingClientRect = function (param) {
    return Belt_Option.map(Curry._1(getSourceEl, undefined), function (el) {
      return el.getBoundingClientRect();
    });
  };
  var domRect = getBoundingClientRect(undefined);
  var rect = Belt_Option.map(domRect, function (domRect) {
    return {
      x: domRect.x | 0,
      y: domRect.y | 0,
      width: domRect.width | 0,
      height: domRect.height | 0
    };
  });
  var enterDuration;
  switch (breakpoint) {
    case /* Xs */0:
    case /* Sm */1:
      enterDuration = 250;
      break;
    case /* Md */2:
      enterDuration = 300;
      break;
    case /* Lg */3:
      enterDuration = 350;
      break;
    case /* Xl */4:
      enterDuration = 400;
      break;
  }
  var exitDuration;
  switch (breakpoint) {
    case /* Xs */0:
    case /* Sm */1:
      exitDuration = 200;
      break;
    case /* Md */2:
      exitDuration = 250;
      break;
    case /* Lg */3:
      exitDuration = 300;
      break;
    case /* Xl */4:
      exitDuration = 350;
      break;
  }
  var phases = rect !== undefined ? animate ? isOpen ? [[/* Hidden */0, 0], [/* MinimalOverSource */{
    _0: rect
  }, crossFade ? 50 : 0], [/* MinimalFullscreen */1, enterDuration], [/* CompleteFullscreen */2, 0]] : [[/* CompleteFullscreen */2, 0], [/* MinimalOverSource */{
    _0: rect
  }, exitDuration], [/* Hidden */0, crossFade ? 50 : 0]] : isOpen ? [[/* CompleteFullscreen */2, 0]] : [[/* Hidden */0, 0]] : animate ? isOpen ? [[/* MinimalFullscreen */1, 0], [/* CompleteFullscreen */2, 0]] : [[/* CompleteFullscreen */2, 0], [/* MinimalOverSource */{
    _0: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }
  }, exitDuration], [/* Hidden */0, crossFade ? 50 : 0]] : isOpen ? [[/* CompleteFullscreen */2, 0]] : [[/* Hidden */0, 0]];
  var style = {
    height: topOffset > 0 ? "calc(100% - " + CSS$Showside.intToPx(topOffset) + ")" : "100%",
    left: "0",
    position: "fixed",
    top: CSS$Showside.intToPx(topOffset),
    width: "100%",
    zIndex: Belt_Option.getWithDefault(zIndex, "2147483647")
  };
  var match$1 = Sequence$Showside.useSequence(onPhaseChange, allowPhaseChange, phases);
  var phase = match$1[0];
  React.useLayoutEffect(function () {
    return function (param) {};
  }, [phase, autoHideSourceEl]);
  if (phase === 0) {
    return null;
  }
  var tmp = {
    style: style
  };
  if (onTouchEnd !== undefined) {
    tmp.onTouchEnd = Caml_option.valFromOption(onTouchEnd);
  }
  if (onTouchMove !== undefined) {
    tmp.onTouchMove = Caml_option.valFromOption(onTouchMove);
  }
  if (onTouchStart !== undefined) {
    tmp.onTouchStart = Caml_option.valFromOption(onTouchStart);
  }
  return React.createElement("div", tmp, Curry._2(renderForeground, phase, match$1[1]));
}
ExpandSequence.displayName = "ExpandSequence";
var make = ExpandSequence;
export { make };
/* react Not a pure module */